export default __webpack_public_path__ + "static/media/chf.3b1ab128.png";